import React from 'react';
import { Navigate } from 'react-router-dom';
import { AiMindChat } from '../components/AiMindChat';
import { isMendsVisionEnabled } from '../services/MendsVisionService';
import '../styles/mendsAi.css';

/** Mends AI full-page chat (/mente) — lives inside CombinedMenu (CRM sidebar + header). */
const MindPage: React.FC = () => {
  if (!isMendsVisionEnabled()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <AiMindChat />
    </div>
  );
};

export default MindPage;
